/* Oblivion WBS features (1.4.5 fees, 1.4.9 bag extras, 1.4.10 exit offer). Added 14 Oct 2026 on the unpublished copy. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('ob-store-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }

  var PIN_KEY = 'ob_cart_pin';
  function lsGet(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function rupees(paise) { var n = Math.round(paise) / 100; return '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: n % 1 ? 2 : 0 }); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  var threshold = cfg.freeShippingThreshold || 0;
  var hasShipFee = typeof cfg.shippingFee === 'number';
  var hasCodFee = typeof cfg.codFee === 'number';

  /* ---------- 1.4.5: product page shipping and COD line ---------- */
  function shippingSentence() {
    var s = 'Free shipping on orders above ' + rupees(threshold);
    s += hasShipFee ? (', ' + rupees(cfg.shippingFee) + ' below that.') : '. Below that, shipping is shown at checkout.';
    if (hasCodFee) s += cfg.codFee > 0 ? (' Cash on delivery: ' + rupees(cfg.codFee) + ' extra.') : ' No extra charge for cash on delivery.';
    return s;
  }
  document.querySelectorAll('.tax-note').forEach(function (note) {
    if (note.dataset.obFee) return;
    note.dataset.obFee = '1';
    note.textContent = 'Inclusive of all taxes. ';
    var a = el('a', null, shippingSentence());
    a.href = '/policies/shipping-policy';
    note.appendChild(a);
  });

  /* ---------- 1.4.9: bag extras (page and drawer) ---------- */
  function buildExtras(id) {
    var box = el('div', 'ob-cart-extras');
    box.setAttribute('data-ob-cart-extras-built', '');
    var ship = el('div', 'ob-cart-extras__row'); ship.setAttribute('data-ob-ship', ''); box.appendChild(ship);
    var cod = el('div', 'ob-cart-extras__row'); cod.setAttribute('data-ob-cod', ''); box.appendChild(cod);
    var est = el('form', 'ob-cart-extras__eta'); est.noValidate = true;
    var label = el('label', null, 'Delivery estimate'); label.htmlFor = id;
    var row = el('div', 'ob-cart-extras__eta-row');
    var input = el('input'); input.id = id; input.type = 'text'; input.inputMode = 'numeric'; input.maxLength = 6; input.placeholder = 'Enter pincode'; input.autocomplete = 'postal-code'; input.value = lsGet(PIN_KEY);
    var btn = el('button', 'ob-cart-extras__btn', 'Check'); btn.type = 'submit';
    row.appendChild(input); row.appendChild(btn);
    var msg = el('p', 'ob-cart-extras__msg'); msg.setAttribute('role', 'status'); msg.setAttribute('aria-live', 'polite');
    est.appendChild(label); est.appendChild(row); est.appendChild(msg);
    est.addEventListener('submit', function (e) { e.preventDefault(); checkPin(input, msg); });
    box.appendChild(est);
    if (cfg.cartPolicyNote) {
      var pol = el('p', 'ob-cart-extras__policy');
      pol.appendChild(document.createTextNode(cfg.cartPolicyNote + ' '));
      var link = el('a', null, 'Returns & cancellation policy'); link.href = '/policies/refund-policy';
      pol.appendChild(link);
      box.appendChild(pol);
    }
    if (input.value && /^[1-9][0-9]{5}$/.test(input.value)) checkPin(input, msg, true);
    return box;
  }
  function checkPin(input, msg, quiet) {
    var pin = (input.value || '').trim();
    if (!/^[1-9][0-9]{5}$/.test(pin)) { if (!quiet) { msg.textContent = 'Please enter a valid 6-digit pincode.'; input.focus(); } return; }
    msg.textContent = 'Checking delivery for ' + pin + '…';
    var base = String(cfg.eddApi || '').replace(/\/+$/, '');
    fetch(base + '/' + encodeURIComponent(pin) + '?mode=p90', { mode: 'cors', credentials: 'omit', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, j: j }; }); })
      .then(function (res) {
        if (res.status === 404) { msg.textContent = 'We could not find delivery data for ' + pin + '. Please check the pincode, or contact us to confirm delivery before ordering.'; return; }
        if (!res.ok || !res.j || res.j.success === false) throw new Error('api');
        lsSet(PIN_KEY, pin);
        var est = res.j.estimates || {};
        var lo = est.average && est.average.days, hi = (est.p90 && est.p90.days) || res.j.edd_days;
        var span = lo && hi && lo !== hi ? (lo + '–' + hi) : (hi || lo);
        msg.textContent = 'Delivering to ' + pin + ': about ' + span + ' days after dispatch. Orders are dispatched in 1–2 business days.';
      })
      .catch(function () { msg.textContent = 'Could not check delivery right now. Please try again in a moment.'; });
  }
  function updateExtras(box, cart) {
    if (!box || !cart) return;
    var total = cart.total_price || 0;
    var ship = box.querySelector('[data-ob-ship]'), cod = box.querySelector('[data-ob-cod]');
    ship.textContent = '';
    var left = el('span', null, 'Shipping'), right = el('strong');
    if (threshold && total >= threshold) right.textContent = 'Free';
    else right.textContent = hasShipFee ? rupees(cfg.shippingFee) : 'Shown at checkout';
    ship.appendChild(left); ship.appendChild(right);
    if (threshold && total < threshold && total > 0) {
      var nudge = el('small', 'ob-cart-extras__nudge', 'Add ' + rupees(threshold - total) + ' more for free shipping.');
      ship.appendChild(nudge);
    }
    cod.hidden = !hasCodFee;
    if (hasCodFee) { cod.textContent = ''; cod.appendChild(el('span', null, 'Cash on delivery')); cod.appendChild(el('strong', null, cfg.codFee > 0 ? '+' + rupees(cfg.codFee) : 'No extra charge')); }
  }
  var lastCart = window.cart && typeof window.cart.total_price === 'number' ? window.cart : null;
  function shippingNote(scope) {
    var notes = scope.querySelectorAll('.fine-print');
    for (var i = 0; i < notes.length; i++) if (/^\s*Shipping, taxes/i.test(notes[i].textContent)) return notes[i];
    return null;
  }
  // Adds the extras box where it is missing. Only new boxes are filled here, so the drawer observer can't loop.
  function placeExtras() {
    var fresh = [];
    var summary = document.querySelector('.order-summary');
    if (summary && !summary.querySelector('[data-ob-cart-extras-built]')) {
      var note = shippingNote(summary), box = buildExtras('ObCartPin');
      note ? note.parentNode.insertBefore(box, note) : summary.appendChild(box);
      fresh.push(box);
    }
    var drawer = document.getElementById('CartDrawer');
    if (drawer && !drawer.querySelector('[data-ob-cart-extras-built]')) {
      var fp = shippingNote(drawer);
      if (fp) { var dbox = buildExtras('ObDrawerPin'); fp.parentNode.insertBefore(dbox, fp); fresh.push(dbox); }
    }
    if (lastCart) fresh.forEach(function (b) { updateExtras(b, lastCart); });
  }
  function updateAll() { if (lastCart) document.querySelectorAll('[data-ob-cart-extras-built]').forEach(function (b) { updateExtras(b, lastCart); }); }
  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { lastCart = c; placeExtras(); updateAll(); }).catch(function () {});
  }
  document.addEventListener('botanical:cart', function (e) {
    if (e.detail && e.detail.cart) lastCart = e.detail.cart;
    setTimeout(function () { placeExtras(); updateAll(); }, 0);
  });
  var drawerEl = document.getElementById('CartDrawer');
  if (drawerEl && window.MutationObserver) {
    var t;
    new MutationObserver(function (list) {
      var outside = list.some(function (m) { return !(m.target.closest && m.target.closest('[data-ob-cart-extras-built]')); });
      if (!outside) return;
      clearTimeout(t); t = setTimeout(placeExtras, 60);
    }).observe(drawerEl, { childList: true, subtree: true });
  }
  if (document.querySelector('.order-summary') || drawerEl) { if (lastCart) { placeExtras(); updateAll(); } else refreshCart(); }

  /* ---------- 1.4.10: exit offer (home and collection pages) ---------- */
  var exitDlg = document.getElementById('ObExitOffer');
  var EXIT_KEY = 'ob_exit_seen';
  if (exitDlg && cfg.exitEnabled && (cfg.template === 'index' || cfg.template === 'collection')) {
    var days = cfg.exitDelayDays || 7;
    var seen = parseInt(lsGet(EXIT_KEY), 10);
    if (/[?&]customer_posted=true/.test(location.search)) lsSet(EXIT_KEY, String(Date.now() + 3650 * 864e5));
    var blocked = seen && Date.now() - seen < days * 864e5;
    var start = Date.now(), shown = false;
    function otherDialogOpen() { return !!document.querySelector('dialog[open]:not(#ObExitOffer)'); }
    function show() {
      if (shown || blocked || otherDialogOpen() || Date.now() - start < 8000) return;
      shown = true; lsSet(EXIT_KEY, String(Date.now()));
      try { exitDlg.showModal(); } catch (e) { exitDlg.setAttribute('open', ''); }
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'ob_exit_offer_shown' }); } catch (e) {}
    }
    if (!blocked) {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) show(); });
      var lastY = window.scrollY, lastT = Date.now();
      window.addEventListener('scroll', function () {
        var y = window.scrollY, now = Date.now();
        if (now - start > 20000 && lastY - y > 250 && now - lastT < 400 && y > 600) show();
        lastY = y; lastT = now;
      }, { passive: true });
    }
    exitDlg.querySelector('[data-ob-exit-close]').addEventListener('click', function () { exitDlg.close ? exitDlg.close() : exitDlg.removeAttribute('open'); });
    exitDlg.addEventListener('click', function (e) { if (e.target === exitDlg && exitDlg.close) exitDlg.close(); });
  }
})();
